import { AvField, AvForm } from 'availity-reactstrap-validation'
import React from 'react'
import { Col, Row } from 'reactstrap'

const Standard = (props) => {

    const {editPage, data, type, onChange}=props
    const handleInputChange = (e) => {
      const {name, value } = e.target;
      onChange(name, value);
    }
  return (
    <AvForm>
    <Row>
      <Col>
        <label className="form-label mt-3">SKU</label>
        <AvField
          name="sku"
          className="form-control"
          type="text"
          placeholder="Enter SKU"
          onChange={handleInputChange}
          value={data?.sku ||""}
          disabled={editPage}
          validate={{
            required: { value: true, errorMessage: "Please enter SKU" },
            pattern: {
              value: /^.{0,32}$/,
              errorMessage: "Maximum 32 characters allowed",
            },
          }}
        />
      </Col>
     { type === "standard" ? <Col>
        <label className="form-label mt-3">Stock Quantity</label>
        <AvField
          name="inventory"
          type="number"
          className="form-control"
          placeholder="Enter Quantity"
          onChange={handleInputChange}
          value={data?.inventory || ""}
          validate={{
            required: {
              value: true,
              errorMessage: "Please enter Stock Quantity",
            },
            min: {
              value: 1,
              errorMessage: "Minimum value is 1",
            },
            max: {
              value: 10000000,
              errorMessage: "Maximum value is 10000000",
            },
          }}
        />
      </Col>:null}
      <Col>
        <label className="form-label mt-3">Cost Price</label>
        <AvField
          name="costPrice"
          type="number"
          className="form-control"
          placeholder="Enter Price"
          onChange={handleInputChange}
          value={data?.costPrice||""}
          validate={{
            required: {
              value: true,
              errorMessage: "Please enter Cost Price",
            },
            min: {
              value: 1,
              errorMessage: "Minimum value is 1",
            },
            max: {
              value: 10000000,
              errorMessage: "Maximum value is 10000000",
            },
          }}
        />
      </Col>
      <Col>
        <label className="form-label mt-3">Selling Price</label>
        <AvField
          name="sellingPrice"
          type="number"
          className="form-control"
          placeholder="Enter Price"
          onChange={handleInputChange}
          value={data?.sellingPrice || ""}
          validate={{
            required: {
              value: true,
              errorMessage: "Please enter Selling Price",
            },
            min: {
              value: 1,
              errorMessage: "Minimum value is 1",
            },
            max: {
              value: 10000000,
              errorMessage: "Maximum value is 10000000",
            },
          }}
        />
      </Col>
      
    </Row>
    </AvForm>
  )
}

export default Standard
